import React from 'react'
import { Box, Stack, styled } from '@mui/material'

const StyledZeroState = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  flex: 1,
  gap: theme.spacing(1),
  padding: theme.spacing(3),
  fontSize: 12,
  fontWeight: 500,
  textAlign: 'center',
  color: theme.palette.grey['800'],
}))

interface ZeroStateMissingDataProps {
  iconlabel?: string
  iconweight?: string
  message: string
}

const ZeroStateMissingData = ({
  iconlabel,
  iconweight,
  message,
}: ZeroStateMissingDataProps) => {
  return (
    <StyledZeroState>
      <Box sx={{ fontSize: iconweight || '24px' }}>
        <i className={`fa-light fa-${iconlabel || 'circle-exclamation'}`} />
      </Box>
      <Box sx={{ maxWidth: '240px' }}>{message}</Box>
    </StyledZeroState>
  )
}

export default ZeroStateMissingData
